import { defineStore } from 'pinia'
import GrafanaResource from '@/api/resources/grafana'
import { IGrafanaDashboard } from '@/interfaces/api/grafana'
import { useErrorStore } from './error'

interface GrafanaState {
  dashboards: IGrafanaDashboard[]
  currentDashboard: IGrafanaDashboard | null
  currentAccessUrl: string | null
  isLoading: boolean
}

export const useGrafanaStore = defineStore('grafana', {
  state: (): GrafanaState => ({
    dashboards: [],
    currentDashboard: null,
    currentAccessUrl: null,
    isLoading: false,
  }),

  actions: {
    async fetchDashboards() {
      this.isLoading = true
      try {
        const response = await GrafanaResource.getDashboards()
        this.dashboards = response || []
      } catch (error) {
        useErrorStore().setError('Erro ao carregar dashboards do Grafana', error)
        throw error
      } finally {
        this.isLoading = false
      }
    },

    async fetchDashboardById(id: number) {
      this.isLoading = true
      try {
        const response = await GrafanaResource.getDashboardById(id)
        this.currentDashboard = response
      } catch (error) {
        useErrorStore().setError('Erro ao carregar dashboard', error)
        throw error
      } finally {
        this.isLoading = false
      }
    },

    async fetchAccessUrl(id: number) {
      this.isLoading = true
      this.currentAccessUrl = null
      try {
        const response = await GrafanaResource.getDashboardAccessUrl(id)
        this.currentAccessUrl = response?.url || null
        return response?.url
      } catch (error) {
        useErrorStore().setError('Erro ao gerar URL de acesso do dashboard', error)
        throw error
      } finally {
        this.isLoading = false
      }
    }
  }
})
